import { useSkaldElements } from '@skaldaura/devkit'
import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import { useContext, useEffect } from 'react'
import AptarMag from './aptarMag/aptarMag'
export default function AutresInformations(props: any) {
   const { setAnchorButton } = useContext(AnchorButtonContext)
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { headband, setHeadband } = useContext(HeadbandContext)
   const [elements] = useSkaldElements("Aptar Mag")

   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(' ')
      setAnchorButton(['Plan du site', 'Salles de réunion', 'Menu cantine', 'L’Aptar MAG’'])
   }, [])

   useEffect(() => {
      setCounter(counterDefault)
   }, [])

   return (
      <ScrollContainer>
         <AnchorPart anchor={{partName: "PLAN DU SITE", id: 0}} />
         <ScrollSection zoneName='Plan du site'  />
         <AnchorPart anchor={{partName: "SALLES DE RÉUNION", id: 1}} />
         <ScrollSection zoneName='Salles réunion'  />
         <AnchorPart anchor={{partName: "MENU DE LA CANTINE", id: 2}} />
         <ScrollSection zoneName='Menu'  />
         <AnchorPart anchor={{partName: "L'APTAR MAG'", id:3}} />
         {elements.length > 0 && <AptarMag element={elements[0]} />}
      </ScrollContainer>
   )
}
